import React from 'react';

const BASIC_SETTING_ICON_MASK = `url(${process.env.PUBLIC_URL || ''}/basic_setting.svg)`;

const BasicSettingIcon: React.FC = () => (
  <span
    className="cp-basic-setting-icon"
    aria-hidden
    style={{ WebkitMaskImage: BASIC_SETTING_ICON_MASK, maskImage: BASIC_SETTING_ICON_MASK }}
  />
);

export default BasicSettingIcon;
